module.exports = __webpack_public_path__ + "img/photos/bg/junk-yard.jpg";